/**
 * Master enable seam for outbound `traceparent` injection — off by default.
 *
 * The header is not CORS-safelisted, so it preflights every cross-origin call
 * and a gateway that does not allow-list it blocks them. Apps opt in per
 * environment at bootstrap.
 */

let enabled = false;

/** Enable or disable outbound `traceparent` injection for the whole runtime. */
export const configureTracingEnabled = (value: boolean): void => {
  enabled = value;
};

/** Restore the default disabled state (test teardown / reset). */
export const resetTracingEnabled = (): void => {
  enabled = false;
};

/** True when outbound `traceparent` injection is enabled. */
export const isTracingEnabled = (): boolean => enabled;
